module.exports = __webpack_public_path__ + "img/sack_left.b9446bd8.jpg";